import React, { useState } from "react";
import Logo from "../../assets/images/myfx-logo.png";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "./LoginComponent.scss";
import LoginImage from "../../assets/images/login-img.jpg";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import { useNavigate } from "react-router-dom";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import MobileInputCompo from "../Common/PhoneInput/PhoneInput";
import HelperService from "../../Services/HelperService";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState<1 | 2 | 3>(1);
    const [referenceNumber, setReferenceNumber] = useState<string>("");
    const [remember_token, setRememberToken] = useState<string>("");
    const [otp, setOtp] = useState(Array(5).fill('')); // Array to store OTP digits
    const [mobile_number, setMobileNumber] = useState<string>("");
    const [errorFlag, setErrorFlag] = useState<boolean>(false);
    const [otpError, setOtpError] = useState(false);
    // React Hook Form instance
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
    /** Step 1: Send OTP */
    const handleSendOTP = () => {
        if (mobile_number === '' || mobile_number.length <= 9) {
            setErrorFlag(true);
            return;
        }
        const body = {
            dial_code: "+91",
            mobile_number: mobile_number,
        };
        setMobileNumber(mobile_number);
        WebService.beforeLoginAPI({
            action: "restaurant-admin-auth/forgot-password/send-otp",
            body,
            btnId: 'send-otp-btn'
        }).then((response: any) => {
            setReferenceNumber(response.reference_number);
            setStep(2);
        }).catch((error: any) => {
            if (error.response.data.message == 'Otp already sent') {
                setStep(2);
            }
        });
    };
    const handleResendOTP = () => {
        const body = {
            dial_code: "+91",
            mobile_number: mobile_number,
        };
        WebService.beforeLoginAPI({
            action: "restaurant-admin-auth/forgot-password/resend-otp",
            body,
            btnId: 'resend-otp-btn'
        }).then((response: any) => {
            setReferenceNumber(response.reference_number);
            setStep(2);
        }).catch((error: any) => {

        });
    };

    /** Step 2: Verify OTP */
    const handleVerifyOTP = (data: any) => {
        if (otp.some(digit => digit === '')) {
            setOtpError(true);
            return;
        } else {
            setOtpError(false);
        }
        const body = {
            dial_code: "+91",
            mobile_number: mobile_number,
            reference_number: referenceNumber,
            otp: otp.join(''),
        };
        WebService.beforeLoginAPI({
            action: "restaurant-admin-auth/forgot-password/verify-otp",
            body,
            btnId: 'verify-otp-btn'
        }).then((response: any) => {
            setRememberToken(response.remember_token);
            setStep(3); // go to password reset step
        }).catch((error: any) => {
        });
    };

    /** Step 3: Reset Password */
    const handleResetPassword = (data: any) => {
        const body = {
            remember_token: remember_token,
            new_password: data.new_password,
        };
        WebService.beforeLoginPutAPI({
            action: "restaurant-admin-auth/forgot-password/reset-password",
            body,
            btnId: 'reset-password-btn'
        }).then((response: any) => {
            navigate("/login");
        }).catch((error: any) => {
            console.error("Password reset failed", error);
        });
    };
    const handleChange = (value: string, index: number) => {
        if (!/^\d*$/.test(value)) return; // Allow only numeric input
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        setOtpError(false);
        // Automatically focus the next input if a digit is entered
        if (value && index < 5) {
            const nextInput = document.getElementById(`otp-input-${index + 1}`);
            if (nextInput) (nextInput as HTMLInputElement).focus();
        }
    };
    // Handle backspace and delete key events
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, idx: number) => {
        if ((e.key === 'Backspace' || e.key === 'Delete') && !otp[idx] && idx > 0) {
            const prevInput = document.getElementById(`otp-input-${idx - 1}`);
            if (prevInput) (prevInput as HTMLInputElement).focus();
        }
    };
    const handleToggle = (field: 'NEW' | 'CONFIRM') => {
        if (field === 'NEW') {
            setShowNewPassword((prev: boolean) => !prev);
        } else {
            setShowConfirmPassword((prev: boolean) => !prev);
        }
    };
    const handleMobileChange = (mobile: string, phone: any) => {
        let mobileNo = HelperService.removeDialCodeFromMobile(
            mobile,
            phone.dialCode
        );
        setMobileNumber(mobileNo);
    }
    /** Render form content based on step */
    const renderForm = () => {
        switch (step) {
            case 1:
                return <>
                    <h4 className="text-center font-bold font-24 mb-2">
                        Forgot Password
                    </h4>
                    <p className="text-secondary mb-4 text-center font-16">
                        Enter registered number to recover the password
                    </p>
                    <Form onSubmit={handleSubmit(handleSendOTP)}>
                        <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <MobileInputCompo
                                placeHolder="Enter Mobile Number"
                                value={mobile_number}
                                handlePhoneNumberChange={(mobile, phone) => {
                                    setErrorFlag(false);
                                    handleMobileChange(mobile, phone);
                                }}
                            />
                            {mobile_number === '' && errorFlag && <span className="text-danger font-12">Please Enter Your Mobile Number</span>}
                            {mobile_number.length > 1 && mobile_number.length <= 9 && errorFlag && <span className="text-danger font-12">Please Enter valid Mobile Number</span>}
                        </Form.Group>
                        <div className="text-center">
                            <Button type="submit" id="send-otp-btn" className="btn btn-primary w-100">
                                Send OTP
                            </Button>
                        </div>
                    </Form>
                </>;

            case 2:
                return (
                    <>
                        <h4 className="text-center font-bold font-24 mb-2">Verify OTP</h4>
                        <p className="text-secondary mb-4 text-center font-16">
                            Enter the OTP sent to your registered mobile number
                        </p>
                        <Form onSubmit={handleSubmit(handleVerifyOTP)}>
                            <div className="form-group">
                                <div className="otp-input-group d-flex justify-content-between mb-1">
                                    {Array.from({ length: 6 }).map((_, index) => (
                                        <input
                                            key={index}
                                            id={`otp-input-${index}`}
                                            type="text"
                                            maxLength={1}
                                            className="form-control text-center otp-input"
                                            style={{ width: "50px", marginRight: index < 5 ? "8px" : "0" }}
                                            value={otp[index]}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            onChange={(e) => handleChange(e.target.value, index)}
                                        />
                                    ))}
                                </div>
                                {otpError && <span className="text-danger font-12">Please enter valid OTP</span>}
                            </div>
                            <div className="text-center mt-3">
                                <Button type="submit" id="verify-otp-btn" className="btn btn-primary w-100">
                                    Verify OTP
                                </Button>
                            </div>
                            <div className="text-center mt-3">
                                <button className="btn btn-link" id="resend-otp-btn" onClick={handleResendOTP}>
                                    Resend OTP
                                </button>
                            </div>
                        </Form>
                    </>
                );

            case 3:
                return <>
                    <h4 className="text-center font-bold font-24 mb-2">
                        Create New Password
                    </h4>
                    <p className="text-secondary mb-4 text-center font-16">
                        Enter your new password below
                    </p>
                    <Form onSubmit={handleSubmit(handleResetPassword)}>
                        <Form.Group className="mb-3">
                            <Form.Label>New Password</Form.Label>
                            <div className="input-group">
                                <Form.Control
                                    type={showNewPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    {...register("new_password", {
                                        required: " New password is required",
                                        pattern: {
                                            value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                                            message: "Password must be at least 8 characters long and include letters, numbers, and special characters",
                                        }
                                    })}
                                />
                                <span
                                    className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                    onClick={() => { handleToggle('NEW') }}
                                >
                                    {showNewPassword ? <BsEyeSlash size={16} /> : <BsEye size={16} />}
                                </span>
                            </div>
                            {errors.new_password && (
                                <span className="text-danger font-12">
                                    {errors.new_password.message?.toString()}
                                </span>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>
                            <div className="input-group">
                                <Form.Control
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    {...register("confirm_password", {
                                        required: "Confirm password is required",
                                        validate: (value: string) =>
                                            value === (document.getElementsByName("new_password")[0] as HTMLInputElement)?.value || "Passwords do not match",
                                    })}
                                />
                                <span className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                    onClick={() => { handleToggle('CONFIRM') }} >
                                    {showConfirmPassword ? <BsEyeSlash size={16} /> : <BsEye size={16} />}
                                </span>
                            </div>
                            {errors.confirm_password && (
                                <label
                                    title={errors?.confirm_password?.message?.toString()}
                                    className="text-danger font-12"
                                >
                                    {errors?.confirm_password?.message?.toString()}
                                </label>
                            )}
                        </Form.Group>
                        <div className="text-center">
                            <Button type="submit" id="reset-password-btn" className="btn btn-primary w-100">
                                Reset Password
                            </Button>
                        </div>
                    </Form>
                </>;

            default:
                return null;
        }
    };

    return (
        <div className="login-page">
            <Container fluid className="p-0">
                <Row className="mx-0 gx-0">
                    <Col className="d-none d-lg-flex justify-content-center align-items-center">
                        <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={LoginImage}
                                width="100%"
                                className="login-img"
                                alt="Login Img"
                            />
                        </div>
                    </Col>
                    <Col
                        lg={5}
                        className="d-flex align-items-center justify-content-center mx-auto"
                    >
                        <Row className="justify-content-center w-100">
                            <Col lg={10} className="form-col">
                                <div className="px-2">
                                    <div className="px-lg-5 px-3 py-5 ">
                                        <div className="mb-4 text-center">
                                            <img className="cursor-pointer" onClick={() => navigate('/login')} src={Logo} width="150" height={150} alt="Logo" />
                                        </div>
                                        {renderForm()}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ForgotPassword;
